export const boardGrorups = [
  {
    id: 'activity',
    ids: ['18','26','27','29','38', '35'],
    list: [
      {boardId: '18', title: '풀씨'},
      {boardId: '26', title: '풀꽃'},
      {boardId: '27', title: '풀숲'},
      {boardId: '29', title: '시민과학풀씨'},
      {boardId: '38', title: '국제풀씨'},
      {boardId: '35', title: '카카오뱅크 에코실험실'},
    ]
  }
]
